import { useEffect, useState } from 'react';
import sanitizeContractHtml from '../helpers/sanitizeContractHtml';

/**
 * Fetches one agreement/acknowledgment document via `fetcher(id)` (expected to resolve
 * to `{ contract: '<html>' }`, matching every existing contract-fetch method in
 * useApi.js) and returns its sanitized HTML, a loading flag, and any fetch error.
 */
export default function useAgreementContract(fetcher, id) {
  const [contractHtml, setContractHtml] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const response = await fetcher(id);
        if (response?.contract) {
          setContractHtml(sanitizeContractHtml(response.contract));
        }
      } catch (fetchError) {
        setError(fetchError);
      } finally {
        setLoading(false);
      }
    };
    load();
    // Runs once on mount, deliberately not depending on `fetcher`/`id`: every existing
    // page in this codebase (LeaseAgreement.js, AonAgreement.js, WarrantyAgreement.js,
    // PriceTagDisclosures.js) fetches its contract in a mount-only effect for the same
    // reason — functions returned from useApi() are recreated on every render of the
    // calling component, so including them in a dependency array would refetch forever.
  }, []);

  return { contractHtml, loading, error };
}
